import React from "react";
import { connect } from "react-redux";
import { getArticle, createArticle } from "../../actions/forum";
import { USER_ROLES } from "../../utils/constant";
import { getRole, capitalize } from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert,
  Input
} from "reactstrap";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import ArticleForm from "../../components/userforums/ArticleForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";

class ForumNewPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {
        category_ids: []
      },
      editable: false
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article
    });
  }

  onContentChange(model) {
    let value = model;
    let article = this.state.article;
    article["body"] = value;
    this.setState({
      article: article
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(value);
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  submitArticle() {
    let { article } = this.state;
    const category_ids = article.category_ids;
    const title = article.title;
    const body = article.body;
    const status = "published";
    this.props.createArticle({
      category_ids,
      title,
      body,
      status
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    let {
      getArticleRequest,
      errorMsg,
      errors,
      editArticleRequest
    } = this.props.forum;
    const coverImg = this.state.croppedImageUrl
      ? this.state.croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "60%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      background:
        'url("' +
        coverImg +
        '") center center / cover no-repeat rgb(255, 255, 255)'
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer"
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer"
    };

    return (
      <Container className="mt-4" fluid>
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>發帖子</div>
              <div className="d-flex align-items-center">
                <Button color="secondary" type="button">
                  返回
                </Button>
              </div>
            </div>
          </CardHeader>
          <OverlayLoading loading={getArticleRequest}>
            <CardBody className="row">
              <div className="col-lg-8 px-4">
                <TextEditor
                  content={this.state.article ? this.state.article.body : ""}
                  onContentChange={this.onContentChange}
                />
              </div>
              <div className="col-lg-4 px-4">
                {errorMsg && (
                  <UncontrolledAlert color="danger" fade={false}>
                    <span className="alert-inner--text">{errorMsg}</span>
                  </UncontrolledAlert>
                )}
                <ArticleForm
                  data={this.state.article}
                  onTextInputChange={this.onTextInputChange}
                  handleCheckBoxChange={this.handleCheckBoxChange}
                  submitArticle={this.submitArticle}
                  loading={editArticleRequest}
                />
              </div>
            </CardBody>
          </OverlayLoading>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    forum: state.forum,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticle: params => dispatch(getArticle(params)),
    createArticle: params => dispatch(createArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumNewPage);
